<template>
    <div class="content work_wrapper search_content">
        <v-row class="search_box">
            <v-col>
              <searchBar @getKey="getKey"></searchBar>
            </v-col>
        </v-row>
        <v-row class="conter_outer">
            <v-col sm="12" md="2" class="left_side_outer" :class="{'d-none': collapse}">
                <filterSide :keyValue="keyValue" :change="change" @setChange="setChange" @filterChange="filterChange" @secondFilter="secondFilter"></filterSide>
            </v-col>
            <v-col sm="12" :md="layoutRight" :class="{'result_right_outer2': true,'collapse': collapse}">
                <div class="right_side_outer fix_icon_wrapper result_content" :class="{'collapse': collapse}">
                    <div v-if="!collapse" class="fixed_icon hidden-sm-and-down hand" @click="handleLeft">
                    <v-icon>mdi-chevron-double-left</v-icon>
                    </div>
                    <div v-if="collapse" class="fixed_icon1 hidden-sm-and-down hand" @click="handleLeft">
                        <v-icon>mdi-chevron-double-right</v-icon>
                    </div>
                    <div v-if="!collapse" class="fixed_icon iphone_icon d-md-none hand" @click="handleLeft">
                        <v-icon>mdi-chevron-double-left</v-icon>
                    </div>
                    <div v-if="collapse" class="fixed_icon1 iphone_icon d-md-none hand" @click="handleLeft">
                        <v-icon>mdi-chevron-double-right</v-icon>
                    </div>
                    <div class="flex_style left public_notice_wrapper" v-if="false">
                        <div class="icon"></div>
                        <div class="text">因系统升级维护，专利附图与PDF原文在此期间将无法浏览，由此给您带来的不便，深表歉意。我们将尽快恢复对您的服务，感谢您的理解和支持！</div>
                    </div>
                    <div class="flex_style betw topName bread_route">
                        <div class="flex_style left" @click="goBack">
                            <v-icon class="active">mdi-chevron-left</v-icon>
                            <span class="active">返回上一页</span>
                            <!--<v-icon>mdi-chevron-right</v-icon>
                            <span>简单检索</span> -->
                        </div>
                        <div class="text"><span>共</span><span class="cor_blue">{{total}}</span><span>条专利</span></div>
                    </div>
                    <div class="right_side">
                        <v-row class="nav_top_btns">
                            <v-col xs="12">
                                <div class="btns_list">
                                    <div class="flex_style left">
                                        <div class="btn_list_item">
                                            <div class="btn_item imgt_icon hand" :class="{'active': showList.imageText}" title="图文展示"  @click="changeShow('imageText')"><i class="i_icon"></i></div>
                                            <div class="btn_item table_icon hand" :class="{'active': showList.tables,'hidden-xs-only': true}" title="表格展示" @click="changeShow('tables')"><i class="i_icon"></i></div>
                                            <div class="btn_item fullImg_icon hand" :class="{'active': showList.fullText}" title="全文附图"  @click="changeShow('fullText')"><i class="i_icon"></i></div>
                                        </div>
                                        <div class="btn_item hand highlight" v-if="showList.imageText" @click="openHighlight" title="高亮"><v-icon>mdi-white-balance-sunny</v-icon><span class="text">高亮</span></div>
                                        <div class="btn_item hand select type1" v-if="showMerge">
                                            <v-select
                                                @change="mergeChange"
                                                v-model="mergeValue"
                                                placeholder="选择筛选排序"
                                                :items="mergeList"
                                                label=""
                                                :dense="true"
                                                item-text="key"
                                                item-value="value"
                                                hide-details
                                                outlined>
                                            </v-select>
                                        </div>
                                        <div class="btn_item hand select">
                                            <v-select
                                                @change="sortChange"
                                                v-model="sortValue"
                                                placeholder="选择筛选排序"
                                                :items="sortList"
                                                label=""
                                                :dense="true"
                                                item-text="key"
                                                item-value="value"
                                                hide-details
                                                outlined>
                                            </v-select>
                                        </div>
                                        <div class="btn_item hand analy_icon hidden-xs-only">
                                            <router-link :to="'/analyse/classify/all?str='+ keyValue +'&from=search'" class="menu_icon" title="数据分析" target="_blank">
                                                <div class="item_icon">
                                                    <span class="icon"></span>
                                                    <span class="text">数据分析</span>
                                                </div>
                                                <!-- <v-icon>mdi-google-analytics</v-icon> -->
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="flex_style right result_right" style="height:100%">
                                        <div class="btn_item d-md-none">
                                            <router-link :to="'/analyse/classify/all?str='+ keyValue +'&from=search'" class="menu_icon" title="数据分析" target="_blank"><v-icon>mdi-google-analytics</v-icon></router-link>
                                        </div>
                                        <div class="btn_item hand space hidden-md-and-down"><v-btn :dense="true" @click="addSpaces">加入工作空间</v-btn></div>
                                        <div class="btn_item hand copy hidden-md-and-down" @click="copyStrate"><v-btn :dense="true">复制检索式</v-btn></div>
                                        <div class="btn_item hand save hidden-md-and-down" style="margin-right: 0;" @click="saveStrate"><v-btn :dense="true">保存检索式</v-btn></div>
                                        <div class="btn_item hand space1 hidden-lg-and-up" title="加入工作空间" @click="addSpaces"></div>
                                        <div class="btn_item hand copy1 hidden-lg-and-up" title="复制检索式" @click="copyStrate"></div>
                                        <div class="btn_item hand save1 hidden-lg-and-up" title="保存检索式" @click="saveStrate"></div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                        <contents :queries="queries" :baz="baz" :showList="showList" :result="result" :allFilter="allFilter" @getSelectKeys="getSelectKeys" @getKey1="getKey1" @spaceInfoChange="spaceInfoChange"></contents>
                        <v-row>
                            <v-col class="common_page">
                                <span class="text hidden-xs-only">共{{total}}条记录</span>
                                <v-pagination
                                    v-model="page"
                                    :length="length"
                                    :total-visible="7"
                                    >
                                </v-pagination>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-overlay :value="isLoading">
        <v-progress-circular
            indeterminate
            size="64"
        ></v-progress-circular>
        </v-overlay>
        <v-dialog
            v-model="addSpace"
            width="600"
            >
            <v-card>
                <v-card-title>加入工作空间 <v-icon @click="handleAddCancel">mdi-close</v-icon></v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <div class="addSpace_wrapper">
                        <div v-if="!singleSpace">
                            <div class="part_title">选择加入方式</div>
                            <div class="radio_part">
                                <v-radio-group v-model="range" hide-details>
                                    <div class="radio_item">
                                        <v-radio label="选中文件" value="0"></v-radio>
                                    </div>
                                    <div class="radio_item">
                                        <v-radio label="选择范围" value="1"></v-radio>
                                        <div class="input_width">
                                            <v-text-field
                                            v-if="range=='1'"
                                            hide-details="auto"
                                            outlined
                                            placeholder="请输入专利序号范围，例：1-20"
                                            v-model="scope"
                                            ></v-text-field>
                                        </div>
                                    </div>
                                    <div class="radio_item">
                                        <v-radio label="自动收录" value="2"></v-radio>
                                        <div class="sel_width" v-if="range=='2'">
                                            <!-- <p>检索式</p>
                                            <v-textarea
                                            solo
                                            v-model="searchFilter"
                                            name="input-7-4"
                                            label="检索式"
                                            ></v-textarea> -->
                                            <v-select
                                            :items="sItems"
                                            item-text="text"
                                            v-model="upset"
                                            item-value="value"
                                            label="收录设置"
                                            outlined
                                            hide-details
                                            ></v-select>
                                        </div>
                                    </div>  
                                </v-radio-group>   
                            </div>
                        </div>
                        <div class="part_title">选择工作空间</div>
                        <div class="space_part">
                            <div class="flex_style left">
                                <span class="common_input_style sel_part" v-if="spaceList&&spaceList.length>0"> 
                                    <v-select
                                    :items="spaceList"
                                    item-text="name"
                                    item-value="id"
                                    label=""
                                    placeholder="工作空间"
                                    hide-details="true"
                                    outlined
                                    @change="spaceChange"></v-select>
                                </span>
                                <span class="addBtn" @click="addNew"><v-icon>mdi-plus</v-icon><span class="text">新建工作空间</span></span>
                            </div>
                            <div class="space_box" v-if="id">
                                <div class="top_tips">
                                    <span class="text1">选择文件夹</span>
                                    <span class="addBtn" @click="addFolder"><v-icon>mdi-plus</v-icon><span class="text">新建文件夹</span></span>
                                </div>
                                <div class="filter_list">
                                    <div class="folder_page">
                                        <v-treeview
                                            :open="initiallyOpen"
                                            :items="list"
                                            activatable
                                            item-key="id"
                                            open-on-click
                                        >
                                            <template v-slot:prepend="{ item, open }">
                                                <div class="flex_style left">
                                                    <v-radio-group v-model="folderKeys">
                                                        <v-radio
                                                            label=""
                                                            :value="item.id"
                                                        ></v-radio>
                                                    </v-radio-group>
                                                    <v-icon v-if="!item.file">
                                                        {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                                                    </v-icon>
                                                    <v-icon v-else>
                                                        {{ files[item.file] }}
                                                    </v-icon>
                                                </div>
                                            </template>
                                            <template v-slot:label="{item}">
                                                <div class="flex_style left">
                                                    <span :title="item.name" >{{item.name}}</span>
                                                    <div class="opt marleft">
                                                        <!-- @click="getDetail(item)" -->
                                                        <v-icon @click="changeFolder(item)">mdi-pencil-box-outline</v-icon>
                                                        <v-icon @click="deleteFolder(item)">mdi-delete-outline</v-icon>
                                                    </div>
                                                </div>
                                            </template>
                                        </v-treeview> 
                                        <!-- <v-list dense>
                                            <v-list-item-group
                                            v-model="folderKeys"
                                            :multiple="false"
                                            color="primary">
                                                <div>
                                                    <foldTree v-if="id" :treeData="list" :spaceId="id" :dialogTag="true" :isAdd="isAdd" @getData="getAdd"></foldTree>
                                                </div>
                                            </v-list-item-group>
                                        </v-list> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="handleAddCancel">取消</v-btn>
                    <v-btn color="primary" @click="handleAddOk">确定</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="addVisible" width="500">
            <v-card>
            <v-card-title class="lighten-2">{{visibleTit}} <v-icon @click="handleAddCancel1">mdi-close</v-icon></v-card-title>
            <v-divider></v-divider>
            <v-card-text>
            <v-form>
                <v-container>
                <v-row>
                    <v-col
                    cols="12"
                    >
                    <div class="h36">
                        <v-text-field
                            v-model="form.name"
                            label="名称"
                            required
                            outlined
                            :dense="true"
                            placeholder="请输入名称"
                        ></v-text-field>
                    </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col
                    cols="12"
                    >
                    <div class="h36">
                        <v-text-field
                            v-model="form.description"
                            label="描述"
                            required
                            outlined
                            :dense="true"
                            placeholder="请输入描述"
                        ></v-text-field>
                    </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <div class="flex_style left work_mask">
                            <span>封面</span>
                            <div class="mask_box">
                                <div :class="'img_icon icon'+ maskImg"></div>
                                <div class="icon" @click="changeMasks">更换</div>
                            </div>
                            <!-- <div :class="['img_icon', 'icon'+maskImg]" ></div>
                            <v-btn @click="changeMasks">更换封面</v-btn> -->
                        </div>
                    </v-col>
                </v-row>
                </v-container>
            </v-form>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="handleAddCancel1">取消</v-btn>
            <v-btn color="primary" @click="handleAddOk1">
                确定
            </v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="addMask" width="500">
            <v-card>
                <v-card-title>选择封面 <v-icon @click="addMask= false">mdi-close</v-icon></v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <div class="work_mask mask_icon">
                        <div :class="['img_icon',{'active': maskIndex==n}, 'icon'+n]" v-for="n in 8" :key="n" @click="maskIndex=n"></div>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="handleMaskCancel">取消</v-btn>
                    <v-btn color="primary" @click="handleMaskOk">确定</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="saveDialog" width="500">
            <v-card>
                <v-card-title>保存检索式 <v-icon @click="saveDialog= false">mdi-close</v-icon></v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <div class="margbsm">
                        <p>保存的检索式：
                        {{this.savedStrategy}}</p>
                    </div>
                    <div class="common_input_style margbsm">
                        <v-text-field
                        label=""
                        hide-details
                        outlined
                        placeholder="为了方便您搜索，请为检索式命名"
                        v-model="strateName"
                        ></v-text-field>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="handleSaveCancel">取消</v-btn>
                    <v-btn color="primary" @click="handleSaveOk">确定</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
         <v-dialog v-model="addVisible1" width="500">
            <v-card>
            <v-card-title class="lighten-2">{{visibleTit1}} <v-icon @click="handleAddCancel2">mdi-close</v-icon></v-card-title>
            <v-divider></v-divider>
            <v-card-text>
            <v-form>
                <v-container>
                <v-row>
                    <v-col
                    cols="12"
                    >
                    <div class="h36">
                        <v-text-field
                            v-model="form1.name"
                            label="名称"
                            required
                            outlined
                            :dense="true"
                            placeholder="请输入名称"
                        ></v-text-field>
                    </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col
                    cols="12"
                    >
                    <div class="h36">
                        <v-text-field
                            v-model="form1.description"
                            label="描述"
                            required
                            outlined
                            :dense="true"
                            placeholder="请输入描述"
                        ></v-text-field>
                    </div>
                    </v-col>
                </v-row>
                </v-container>
            </v-form>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                @click="handleAddCancel2">
                取消
            </v-btn>
            <v-btn
                color="primary"
                @click="handleAddOk2"
                v-if="visibleTit1 =='新建文件夹'"
            >
                确定
            </v-btn>
            <v-btn
                color="primary"
                @click="handleEditOk2"
                v-if="visibleTit1 =='修改文件夹'"
            >
                确定
            </v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
         <v-dialog v-model="highDialog" width="500">
            <v-card class="highlight_wrapper">
                <v-card-title class="lighten-2">高亮 （1-6个关键词） <v-icon @click="handleCancel3">mdi-close</v-icon></v-card-title>
                <v-divider></v-divider>
            <v-card-text>
            <v-form>
                <v-container>
                <v-row>
                    <v-col sm="4">
                        <div class="color_icon color1"></div>
                        <div class="common_input_style">
                            <v-text-field
                                v-model="colorType.key1"
                                label=""
                                required
                                outlined
                                :dense="true"
                                placeholder="请输入关键字"
                            ></v-text-field>
                        </div>
                    </v-col>
                    <v-col sm="4">
                        <div class="color_icon color2"></div>
                        <div class="common_input_style">
                           <v-text-field
                                v-model="colorType.key2"
                                label=""
                                required
                                outlined
                                :dense="true"
                                placeholder="请输入关键字"
                            ></v-text-field>
                        </div>
                    </v-col>
                    <v-col sm="4">
                        <div class="color_icon color3"></div>
                        <div class="common_input_style">
                           <v-text-field
                                v-model="colorType.key3"
                                label=""
                                required
                                outlined
                                :dense="true"
                                placeholder="请输入关键字"
                            ></v-text-field>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                   <v-col sm="4">
                       <div class="color_icon color4"></div>
                        <div class="common_input_style">
                           <v-text-field
                                v-model="colorType.key4"
                                label=""
                                required
                                outlined
                                :dense="true"
                                placeholder="请输入关键字"
                            ></v-text-field>
                        </div>
                   </v-col>
                    <v-col sm="4">
                       <div class="color_icon color5"></div>
                        <div class="common_input_style">
                           <v-text-field
                                v-model="colorType.key5"
                                label=""
                                required
                                outlined
                                :dense="true"
                                placeholder="请输入关键字"
                            ></v-text-field>
                        </div>
                   </v-col>
                    <v-col sm="4">
                       <div class="color_icon color6"></div>
                        <div class="common_input_style">
                           <v-text-field
                                v-model="colorType.key6"
                                label=""
                                required
                                outlined
                                :dense="true"
                                placeholder="请输入关键字"
                            ></v-text-field>
                        </div>
                   </v-col>
                </v-row>
                </v-container>
            </v-form>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                @click="handleCancel3">
                取消
            </v-btn>
            <v-btn
                color="primary"
                @click="handleOk3"
            >
                确定
            </v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import searchBar from "@/components/widgets/searchBar.vue";
import filterSide from '@/components/side/filterSide.vue';
import contents from "@/components/side/content1.vue";
import foldTree from '@/components/side/foldTree.vue'
import { mapActions, mapState} from 'vuex'
import Qs from 'qs'
export default {
    data() {
        return {
            layoutRight: 10,
            collapse: false,
            items: ['简单同族编号','申请号升序','申请号降序'],
            contents: true,
            analysis: false,
            addSpace: false,
            rules: {},
            range: '',
            sItems: [
                {
                    text: '仅收录更新专利',
                    value: '0'
                },
                {
                    text: '当前检索结果及以后专利',
                    value: '1'
                }
            ],
            // 'analysis': false,
            showList: {
                'tables': false,   
                'imageText': true,
                'fullText': false
            },
            analyKey: '',
            keyValue: '',
            result: {},
            result1: [
            ],
            result2: [
            ],
            result3: [
            ],
            total: 0,
            page: 1,
            pageSize: 16,
            page1: 1,
            pageSize1: 16,
            page2: 1,
            pageSize2: 10,
            page3: 1,
            pageSize3: 24,
            fcKey: [],
            length: 0,
            showMerge: false,
            mergeValue: 'none',
            mergeList: [
                {
                    key: '不合并',
                    value: 'none'
                },
                {
                    key: '申请号合并',
                    value: 'an'
                }
            ],
            sortList: [
                {
                    key: '相关度',
                    value: 'score!'
                },
                {
                    key: '申请日期 ↓',
                    value: 'ad!'
                },
                {
                    key: '申请日期 ↑',
                    value: 'ad'
                },
                {
                    key: '公开/公告日 ↓',
                    value: 'dd!'
                },
                {
                    key: '公开/公告日 ↑',
                    value: 'dd'
                },
                {
                    key: '专利评级',
                    value: 'rank!'
                }
            ],
            sortValue: '',
            spaceList: [],
            list: [],
            id: 0,
            folderKeys: '',
            isAdd: false,
            scope: '',
            upset: '',
            searchFilter: '',
            selectStr: '',
            addVisible: false,
            addVisible1: false,
            form: {},
            form1: {},
            visibleTit: '添加工作空间',
            visibleTit1:'新建文件夹',
            maskImg: 1,
            maskIndex: 1,
            addMask: false,
            savedStrategy: '',
            saveDialog: false,
            strateName: '',
            fcKey1: '',
            isLoading: false,
            filterq2: '',
            allFilter: {},
            initiallyOpen: [],
            change: false,
            highDialog: false,
            colorType: {
                key0: '',
                key1: '',
                key2: '',
                key3: '',
                key4: '',
                key5: '',
                key6: ''
            },
            queries: [],
            baz: '',
            simage: false,
            singleSpace: false,
            spaceInfo: {}
        }
    },
    components: {
        searchBar,
        filterSide,
        contents,
        foldTree
    },
    computed: {
        saveFilterData() {
            let data = []
            if(this.$store.state.saveFilterData) {
                data = JSON.parse(this.$store.state.saveFilterData)
            }
            return data
        }
    },
    created() {
        this.$store.commit('setMenuMini', false)
        if(this.$vuetify.breakpoint.name=='sm' || this.$vuetify.breakpoint.name == 'xs') {
            this.collapse = true
            this.showList = {
                'tables': false,
                'imageText': true,
                'fullText': false
            }
        }
      
    },  
    mounted() {
        this.$store.commit('setMenuMini', false)
        if(this.$route.query.model == 'simage') {
            this.simage = true
            this.showList = {
                'tables': false,
                'imageText': false,
                'fullText': true
            }
        }else {
            if(sessionStorage.getItem('res-showList')) {
                this.showList = JSON.parse(sessionStorage.getItem('res-showList'))
                if(this.showList.tables) {
                    this.page = this.page1
                    this.pageSize = this.pageSize1
                }
                if(this.showList.imageText) {
                    this.page = this.page2
                    this.pageSize = this.pageSize2
                }
                if(this.showList.fullText) {
                    this.page = this.page3
                    this.pageSize = this.pageSize3
                }
            }
           this.sortValue = sessionStorage.getItem('res-sortVal') || ''
        }
        if(sessionStorage.getItem('highlight')) {
            this.colorType = JSON.parse(sessionStorage.getItem('highlight'))
            let arr = []
            for(let i in this.colorType) {
                arr.push(this.colorType[i])
            }
            this.queries = arr
            this.baz = this.colorType
        }      
    },
    watch: {
        page(val) {
            if(this.showList.tables) {
                this.page1 = val
            }
            if(this.showList.imageText) {
                this.page2 = val
            }
            if(this.showList.fullText) {
               this.page3 = val
            }
            this.getResultBykey()
        },
        saveFilterData(val) {
            this.fcKey = val
        }
    },
    methods: {
        ...mapActions('search',['querySearch','joinSpace','strategyView','saveStrategy']),
        ...mapActions('space',['getSpaces','newSpace']),
        ...mapActions('folder',['folderSet','newFolder','delFolder','editFolder']),
        openHighlight() {
            this.highDialog = true
        },
        setChange(val) {
            this.change = val
        },
        goBack() {
            this.$router.push({
                path: '/search',
            })
        },
        successMsg(msg) {
            this.$message({
                type: 'success',
                message: msg || '操作成功!'
            })
        },
        failMsg(msg) {
            this.$message({
                type: 'error',
                message: msg || '操作失败!'
            })
        },
        handleLeft() {
            this.collapse = !this.collapse
            this.layoutRight = this.collapse? 12: 10
        },
        getKey(val) {
            if(val) {
                this.keyValue = val
                this.change = true
                this.getResultBykey()
            }
        },
        getKey1(val) {
            if(val) {
                this.keyValue = val
                this.change = true
                this.getResultBykey()
            }
        },
        getSelectKeys(val) {
            if(val) {
                this.selectStr = val.join(',')
            }else {
                this.selectStr = ''
            }
        },
        changeShow(val) {
            this.analyKey = ''
            this.contents = true
            this.analysis = false
            if(val=='tables') {
                this.showList = {
                    'tables': true,
                    'imageText': false,
                    'fullText': false
                }
            }
            if(val =='imageText') {
                this.showList = {
                    'tables': false,
                    'imageText': true,
                    'fullText': false
                }
            }
            // if(val =='imageText') {
            //     this.showList = {
            //         'tables': false,
            //         'imageText': true,
            //         'fullText': false
            //     }
            // }
            if(val == 'fullText') {
                this.showList = {
                    'tables': false,
                    'imageText': false,
                    'fullText': true
                }
            }
            sessionStorage.setItem('res-showList', JSON.stringify(this.showList))
            this.getResultBykey()
        },
        filterChange(val) {
            this.fcKey = val.length>0? val: ''
            this.getResultBykey()
        },
        secondFilter(val) {
            this.filterq2 = val.length>0? val: ''
            this.getResultBykey()
        },
        getResultBykey() {
            if(sessionStorage.getItem('res-showList')) {
                this.showList = JSON.parse(sessionStorage.getItem('res-showList'))
            }
            let ds = 'cn'
            if(this.showList.tables) {
                this.page = this.page1
                this.pageSize = this.pageSize1
            }
            if(this.showList.imageText) {
                this.page = this.page2
                this.pageSize = this.pageSize2
            }
            if(this.showList.fullText) {
                this.page = this.page3
                this.pageSize = this.pageSize3
            }
            this.isLoading = true
            let country = localStorage.getItem('countries')
            if(country) {
                country = JSON.parse(country)
                if(country.length==1) {
                    ds = country[0]
                }else if(country.length==116){
                    ds = 'all'
                }else {
                    ds = 'cn'
                }
            }
            let mValue = ''
            if(ds == 'cn') {
                this.showMerge = true
                mValue = this.mergeValue
            }else {
                this.showMerge = false
                mValue = ''
            }
            this.sortValue = sessionStorage.getItem('res-sortVal') || 'score!'
            let key = this.fcKey?JSON.stringify(this.fcKey): ''
            this.fcKey1 = key
            let dm = this.showList['tables']? 'list': this.showList['imageText']? 'mix': this.showList['fullText']? 'image': 'image_s'
            if(this.$route.query.model == 'simage') {
                dm = 'image_s'
            }
            let data = {
                params: {
                    fc: key,
                    q: this.keyValue,
                    ds: ds,
                    m: mValue,
                    s: this.sortValue || 'score!',
                    dm: dm,
                    p: this.page,
                    ps: this.pageSize,
                    q2: this.filterq2
                }
            }
            this.allFilter = {
                fc: key,
                q: this.keyValue,
                ds: ds,
                s: this.sortValue,
                dm: dm,
                p: this.page,
                ps: this.pageSize,
                q2: this.filterq2 || ''
            }
            // this.searchFilter = key?(this.keyValue +'AND' + key): this.keyValue
            let _this = this
            console.log(data,10000)
            //搜索专利的pagination.data的数据
            this.querySearch({data: data, handle(res) {
                _this.isLoading = false
                _this.total = res.pagination.total
                // _this.result = res.pagination.data
                if(_this.showList.tables) {
                   _this.result1 = res.pagination.data
                   //专利信息的table的数据
                    console.log(_this.result1,'====_this.result1=====')
                }
                if(_this.showList.imageText) {
                    _this.result2 = res.pagination.data
                }
                if(_this.showList.fullText) {
                   _this.result3 = res.pagination.data
                }
                _this.result = {
                    'list1': _this.result1,
                    'list2': _this.result2,
                    'list3': _this.result3
                }
                _this.length = Math.ceil(_this.total / _this.pageSize)>200?200: Math.ceil(_this.total / _this.pageSize)
                window.scrollTo(0,0);
                _this.setKeyLight()
            }})
        },
        sortChange() {
            sessionStorage.setItem('res-sortVal', this.sortValue)
            this.getResultBykey()
        },
        mergeChange() {
            console.log(1000,this.mergeValue)
            sessionStorage.setItem('res-mergeVal', this.mergeValue)
            this.getResultBykey()
        },
        addSpaces() {
            this.addSpace =  true
            if(this.selectStr.length>0) {
                this.range = '0'
            }else {
                this.range = '1'
            }
            this.getStrate('get')
            this.getWorkspace()
        },
        getWorkspace() {
            let _this = this
            this.getSpaces({handle(res) {
                _this.spaceList = res.workspaces
            }})
        },
        handleAddOk() {
            if(this.range == '0') {
                this.scope = ''
                this.upset = ''
            }
            if(this.range == '1') {
                this.upset = ''
                this.selectStr = ''
            }
            if(this.range == '2') {
                this.scope = ''
                this.selectStr = ''
            }
            let ds = 'cn'
            let country = localStorage.getItem('countries')
            if(country) {
                country = JSON.parse(country)
                if(country.length==1) {
                    ds = country[0]
                }else if(country.length==116){
                    ds = 'all'
                }else {
                    ds = 'cn'
                }
            }
            let data = {
                params: {
                    scopeType: this.range,
                    scope: this.scope,
                    ans: this.selectStr,
                    updateSetting: this.upset ,
                    folderId: this.folderKeys,
                    workspaceId: this.id,
                    searchFilter: this.searchFilter,
                    ds: ds
                }
            }
            let _this = this
            this.joinSpace({data:data,handle(res) {
                if(res.success) {
                    _this.successMsg(res.message)
                    _this.handleAddCancel()
                }else {
                    _this.failMsg(res.message)
                }
            }})
        },
        handleAddCancel() {
            this.addSpace =  false
            this.spaceList = []
            this.list = []
            this.scope = ''
            this.upset = ''
        },
        spaceChange(e) {
            this.id = parseInt(e)
            this.getList()
        },
        getList() {
            let data = {
                params: {
                    workspaceId: this.id
                }
            }
            let _this = this
            this.folderSet({data: data,handle(res) {
                _this.isAdd = false
                let list = res.folders
                list = list.filter((item)=>{
                    return item.level == 0
                })
                _this.list = list
            }})
        },
        addFolder() {
            this.addVisible1 = true
            this.visibleTit1 = '新建文件夹'
            this.form1 = {}
        },
        getAdd(val) {
            if(val) {
                this.getList()
            }
        },
        addNew() {
            this.addVisible = true
            this.form = {}
            this.visibleTit = '添加工作空间'
        },
        handleAddOk1() {
            this.form.iconImageId = this.maskImg
            let data = {
                params: this.form
            }
            let _this = this
            this.newSpace({data: data,handle(res) {
                if(res.success) {
                    _this.successMsg(res.message)
                    _this.addVisible = false
                    _this.getWorkspace()
                }else {
                    _this.failMsg(res.message)
                }
               
            }})
        },
        handleAddCancel1() {
            this.form = {}
            this.addVisible = false
        },
        changeMasks() {
            this.addMask = true
        },
        handleMaskCancel() {
            this.addMask = false
        },
        handleMaskOk() {
            this.addMask = false
            this.maskImg = this.maskIndex
        },
        getStrate(val) {
            let temp = 'q='+ this.keyValue + '&fc='+this.fcKey1 + '&ds=all&q2='+ this.filterq2
            let data = {
                params: {
                    q: this.keyValue,
                    paramPair: temp
                }
            }
            let _this = this 
            this.strategyView({data: data,handle(res) {
                if(res.success) {
                    if(val == 'show') {
                        _this.saveDialog = true
                    }
                    _this.savedStrategy = res.message
                    if(val == 'copy') {
                        _this.$copyText(_this.savedStrategy).then(
                            res => {
                                _this.$message.success("已成功复制，可直接去粘贴");
                            },
                            err => {
                            _this.$message.info("复制失败");
                        })
                    }
                    if(val == 'get') {
                        _this.searchFilter = res.message
                    }
                }
            }})
        },
        saveStrate() {
            this.getStrate('show')
        },
        copyStrate() {
            this.getStrate('copy')
        },
        handleSaveCancel() {
            this.saveDialog = false
            this.strateName = ''
            this.$message({
                iconClass: 'msg_warn',
                message: '已取消保存'
            })
        },
        handleSaveOk() {
            if(!this.strateName) {
                this.$message({
                    type: 'info',
                    message: '请输入检索式名称'
                })
                return false
            }
            let data = {
                params: {
                    name: this.strateName,
                    value: this.savedStrategy
                }
            }
            let _this = this
            this.saveStrategy({data: data,handle(res) {
                _this.saveDialog = false
                if(res.success) {
                    _this.$message({
                        type: 'warning',
                        iconClass: 'msg_success',
                        dangerouslyUseHTMLString: true,
                        message: '<div class="msg_box_wrapper"><span class="text">检索式保存成功! 可前往</span> <span class="link" id="msgbox1">个人中心-历史语句</span><span class="text">进行查询</span></div>',
                        duration: 0,
                        showClose: true
                    })
                    // setTimeout(() => {
                        _this.$nextTick(() => {
                            document.getElementById('msgbox1').addEventListener('click', _this.goHistory)
                        })      
                    // }, 2000);   
                }else {
                    _this.$message({
                        type: 'error',
                        message: '保存失败'
                    })
                }
            }})
        },
        goHistory() {
            this.$message.close()
            this.$message.closeAll()
            this.$router.push({
                path: '/user/history'
            })
        },
        changeFolder(val) {
            this.visibleTit1 = '修改文件夹'
            this.addVisible1 = true
            this.form1.id = val.id
            this.form1.name = val.name
            this.form1.description = val.description
        },
        deleteFolder(val) {
             this.$msgbox.confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {
                    params: {
                        id: val.id
                    }
                }
                let _this = this
                this.delFolder({data: data,handle(res) {
                    if(res.success) {
                        _this.successMsg(res.message)
                        _this.getList()
                    }else {
                        _this.failMsg(res.message)
                    }
                }})
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        handleAddCancel2() {
            this.addVisible1 = false
        },
        handleCancel3() {
            this.highDialog = false
        },
        handleOk3() {
            let arr = []
            for(let i in this.colorType) {
                arr.push(this.colorType[i])
            }
            // this.queries.total = this.colorType
            this.queries = arr
            this.baz = this.colorType
            this.highDialog = false
            sessionStorage.setItem('highlight', JSON.stringify(this.colorType))
        },
        setKeyLight() {
            let arr = []
            if(sessionStorage.getItem('highlight')) {
                this.colorType = JSON.parse(sessionStorage.getItem('highlight'))
                this.colorType.key0 = this.keyValue
            }else {
                this.colorType.key0 = this.keyValue
            }
            for(let i in this.colorType) {
                arr.push(this.colorType[i])
            }
            console.log('colorType', this.colorType)
            console.log('arr', arr)
            this.queries = arr
            // this.colorType.key0 = this.keyValue
            this.baz = this.colorType
            sessionStorage.setItem('highlight', JSON.stringify(this.colorType))
        },
        handleAddOk2() {
            this.form1.workspaceId = this.id
            this.form1.parentFolderId = ''
            let data = {
                params: this.form1
            }
            let _this = this
            this.newFolder({data: data,handle(res) {
                _this.addVisible1 = false
                if(res.success) {
                    _this.$message.success(res.message)
                    _this.getList()
                }else {
                   _this.$message.info(res.message) 
                }
            }})
        },
        handleEditOk2() {
            // this.addVisible1 = false
            let data = {
                params: {
                    folderId: this.form1.id,
                    name: this.form1.name,
                    description: this.form1.description
                }
            }
            let _this = this
            this.editFolder({data: data,handle(res) {
                 _this.addVisible1 = false
                if(res.success) {
                    _this.$message.success(res.message)
                    _this.getList()
                }else {
                   _this.$message.info(res.message) 
                }
            }})
        },
        spaceInfoChange(val) {
            this.addSpace = true
            this.spaceInfo = val
            this.range = '0'
            this.selectStr = val.id
            if(val) {
                this.singleSpace = true
                this.getWorkspace()
            }
        }
    }
}
</script>
